(() => {
  const classify = (link) => {
    const href = link.getAttribute('href') || '';
    const label = (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120);

    if (/activehosted\.com\/f\/1/i.test(href)) return { event: 'siti_newsletter_click', destination: 'mailblue' };
    if (/\/pages\/contact/i.test(href)) return { event: 'siti_contact_click', destination: 'contact' };
    if (/\/pages\/sit-i-academy|\/pages\/academy/i.test(href)) return { event: 'siti_academy_click', destination: 'academy' };
    if (/\/pages\/sit-i-professionals/i.test(href)) return { event: 'siti_professional_click', destination: 'professionals' };
    if (/\/products\//i.test(href)) return { event: 'siti_product_click', destination: 'product' };
    return null;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const conversion = classify(link);
    if (!conversion) return;

    const detail = {
      ...conversion,
      link_url: link.href,
      link_text: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120),
      page_path: window.location.pathname
    };

    window.dataLayer?.push(detail);
    window.Shopify?.analytics?.publish(`sit_i:${conversion.destination}_click`, {
      page_path: detail.page_path,
      link_url: detail.link_url
    });
    window.dispatchEvent(new CustomEvent('siti:conversion', { detail }));
  });

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-siti-model-chooser] [data-choice]');
    if (!choice) return;
    const detail = {
      event: 'siti_model_choice',
      choice_group: choice.closest('[data-choice-group]')?.dataset.choiceGroup || '',
      choice_value: choice.dataset.choice || ''
    };
    window.dataLayer?.push(detail);
    window.Shopify?.analytics?.publish('sit_i:model_choice', {
      choice_group: detail.choice_group,
      choice_value: detail.choice_value
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form[action*="/search"]')) return;
    const query = new FormData(form).get('q');
    if (typeof query !== 'string' || !query.trim()) return;
    window.dataLayer?.push({ event: 'siti_search_submit', page_path: window.location.pathname });
    window.Shopify?.analytics?.publish('sit_i:search_submit', { page_path: window.location.pathname });
  });
})();
